import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { useGetOrgList } from "@src/api/organizations-list/get-organization-list";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import { useIsAgencyAdmin } from "@src/hooks/useIsAgencyAdmin";

export const useShowSlackSettings = () => {
  const isAdmin = useIsAdmin();
  const isAgencyAdmin = useIsAgencyAdmin();
  const orgList = useGetOrgList();
  const adminOrg = useGetOrganizationSummary();
  const hasAgency = !!adminOrg.data?.org?.agencies?.[0]?.agencyId;

  if (isAdmin) return true;

  // Agency admins always see slack settings (they manage the agency integration)
  if (hasAgency && isAgencyAdmin) return true;

  // Non-agency-admin users in agency orgs can still set up their own org-level integration,
  // or see slack settings if they have access to multiple orgs
  return orgList.isSuccess && orgList.data?.orgs?.length > 0;
};
